/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { SET_READY, REFRESH_LOCALE } from 'actions/app';

import {
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILURE,
} from 'actions/user';

import p from 'polyglot/polyglot';

const initialState = () => ({
  fieldsets: [
    {
      legend: '',
      inputs: [
        {
          type: 'text',
          name: 'firstname',
          label: p.t('profile.form.firstname.label'),
          placeholder: p.t('profile.form.firstname.placeholder'),
          constraints: null,
          required: true,
        },
        {
          type: 'text',
          name: 'lastname',
          label: p.t('profile.form.lastname.label'),
          placeholder: p.t('profile.form.lastname.placeholder'),
          constraints: null,
          required: true,
        },
        {
          type: 'text',
          name: 'title',
          label: p.t('profile.form.title.label'),
          placeholder: p.t('profile.form.title.placeholder'),
          constraints: null,
          required: true,
        },
        {
          type: 'text',
          name: 'phone_number',
          label: p.t('profile.form.phone_number.label'),
          placeholder: p.t('profile.form.phone_number.placeholder'),
          constraints: null,
          required: true,
        },
        {
          type: 'text',
          name: 'email',
          label: p.t('profile.form.email.label'),
          placeholder: p.t('profile.form.email.placeholder'),
          constraints: null,
          required: true,
        },
        {
          type: 'textarea',
          name: 'talent_presentation',
          label: p.t('profile.form.talent_presentation.label'),
          placeholder: p.t('profile.form.talent_presentation.placeholder'),
          constraints: null,
          required: true,
          colWidth: 12,
        },
        {
          type: 'googleplaces',
          name: 'location',
          label: p.t('profile.form.location.label'),
          placeholder: p.t('profile.form.location.placeholder'),
          constraints: null,
          required: false,
        },
        {
          type: 'select',
          name: 'language',
          label: p.t('profile.form.language.label'),
          placeholder: p.t('profile.form.language.placeholder'),
          options: [],
          constraints: null,
          required: true,
        },
        {
          type: 'file',
          name: 'id_picture_cloudinary_public_id',
          label: p.t('profile.form.id_picture_cloudinary_public_id.label'),
          placeholder: p.t(
            'profile.form.id_picture_cloudinary_public_id.placeholder'
          ),
          description: p.t(
            'profile.form.id_picture_cloudinary_public_id.description'
          ),
          constraints: null,
          required: true,
        },
        {
          type: 'textarea',
          name: 'signup_intro',
          label: p.t('profile.form.signup_intro.label'),
          placeholder: p.t('profile.form.signup_intro.placeholder'),
          constraints: null,
          required: true,
          colWidth: 12,
        },
        {
          type: 'checkbox',
          name: 'wants_newsletter',
          label: p.t('profile.form.wants_newsletter.label'),
          placeholder: p.t('profile.form.wants_newsletter.placeholder'),
          constraints: null,
          required: false,
          colWidth: 12,
        },
        {
          type: 'checkbox',
          name: 'wants_sms_notifications',
          label: p.t('profile.form.wants_sms_notifications.label'),
          placeholder: p.t('profile.form.wants_sms_notifications.placeholder'),
          constraints: null,
          required: false,
          colWidth: 12,
        },
        {
          type: 'checkbox',
          name: 'wants_incognito',
          label: p.t('profile.form.wants_incognito.label'),
          placeholder: p.t('profile.form.wants_incognito.placeholder'),
          constraints: null,
          required: false,
          colWidth: 12,
        },
        {
          type: 'checkbox',
          name: 'wants_promotion',
          label: p.t('profile.form.wants_promotion.label'),
          placeholder: p.t('profile.form.wants_promotion.placeholder'),
          constraints: null,
          required: false,
          colWidth: 12,
        },
      ],
    },
    {
      legend: p.t('profile.additional_info'),
      inputs: [
        {
          type: 'text',
          name: 'talent_website_url',
          label: p.t('profile.form.talent_website_url.label'),
          placeholder: p.t('profile.form.talent_website_url.placeholder'),
          constraints: null,
          required: false,
        },
        {
          type: 'cleave',
          name: 'model_birth_date',
          label: p.t('profile.form.model_birth_date.label'),
          placeholder: p.t('profile.form.model_birth_date.placeholder'),
          constraints: null,
          required: true,
          options: {
            date: true,
            datePattern: ['Y', 'm', 'd'],
            delimiter: '-',
          },
        },
        {
          type: 'select',
          name: 'model_gender',
          label: p.t('profile.form.model_gender.label'),
          placeholder: p.t('profile.form.model_gender.placeholder'),
          options: {
            MALE: p.t('profile.form.model_gender.options.male'),
            FEMALE: p.t('profile.form.model_gender.options.female'),
          },
          constraints: null,
          required: true,
        },
        {
          type: 'select',
          name: 'model_eye_color',
          label: p.t('profile.form.model_eye_color.label'),
          placeholder: p.t('profile.form.model_eye_color.placeholder'),
          options: [],
          constraints: null,
          required: true,
        },
        {
          type: 'tags',
          name: 'model_shoe_sizes',
          label: p.t('profile.form.model_shoe_sizes.label'),
          placeholder: p.t('profile.form.model_shoe_sizes.placeholder'),
          options: [],
          constraints: null,
          required: false,
        },
        {
          type: 'tags',
          name: 'model_clothing_sizes',
          label: p.t('profile.form.model_clothing_sizes.label'),
          placeholder: p.t('profile.form.model_clothing_sizes.placeholder'),
          options: [],
          constraints: null,
          required: false,
        },
        {
          type: 'select',
          name: 'model_hair_color',
          label: p.t('profile.form.model_hair_color.label'),
          placeholder: p.t('profile.form.model_hair_color.placeholder'),
          options: [],
          constraints: null,
          required: true,
        },
        {
          type: 'text',
          name: 'model_height',
          label: p.t('profile.form.model_height.label'),
          placeholder: p.t('profile.form.model_height.placeholder'),
          constraints: null,
          required: true,
        },
        {
          type: 'text',
          name: 'model_chest',
          label: p.t('profile.form.model_chest.label'),
          placeholder: p.t('profile.form.model_chest.placeholder'),
          constraints: null,
          required: false,
        },
        {
          type: 'text',
          name: 'model_waist',
          label: p.t('profile.form.model_waist.label'),
          placeholder: p.t('profile.form.model_waist.placeholder'),
          constraints: null,
          required: false,
        },
        {
          type: 'text',
          name: 'model_hips',
          label: p.t('profile.form.model_hips.label'),
          placeholder: p.t('profile.form.model_hips.placeholder'),
          constraints: null,
          required: false,
        },
        {
          type: 'checkbox',
          name: 'model_has_tattoos_piercings',
          label: p.t('profile.form.model_has_tattoos_piercings.label'),
          placeholder: p.t(
            'profile.form.model_has_tattoos_piercings.placeholder'
          ),
          constraints: null,
          required: false,
          colWidth: 6,
        },
      ],
    },
    {
      legend: p.t('profile.fieldsets.head_stylist.legend'),
      inputs: [
        {
          type: 'checkbox',
          name: 'stylist_does_face',
          label: p.t('profile.form.stylist_does_face.label'),
          placeholder: p.t('profile.form.stylist_does_face.placeholder'),
          constraints: null,
          required: false,
          colWidth: 3,
        },
        {
          type: 'checkbox',
          name: 'stylist_does_hair',
          label: p.t('profile.form.stylist_does_hair.label'),
          placeholder: p.t('profile.form.stylist_does_hair.placeholder'),
          constraints: null,
          required: false,
          colWidth: 3,
        },
      ],
    },
    {
      legend: p.t('signup.create_portfolio.fieldsets.images.legend'),
      inputs: [
        {
          type: 'image',
          name: 'talent_polaroid_face',
          label: p.t('profile.form.talent_polaroid_face.label'),
          placeholder: p.t('profile.form.talent_polaroid_face.placeholder'),
          preview: p.t('profile.form.talent_polaroid_face.preview'),
          constraints: null,
          required: true,
          index: 0,
          colWidth: 4,
        },
        {
          type: 'image',
          name: 'talent_portfolio_1',
          label: p.t('profile.form.talent_portfolio.label'),
          placeholder: p.t('profile.form.talent_portfolio.placeholder'),
          preview: '',
          constraints: null,
          required: true,
          index: 3,
          colWidth: 4,
        },
        {
          type: 'image',
          name: 'talent_portfolio_2',
          label: p.t('profile.form.talent_portfolio.label'),
          placeholder: p.t('profile.form.talent_portfolio.placeholder'),
          preview: '',
          constraints: null,
          required: true,
          index: 4,
          colWidth: 4,
        },
        {
          type: 'image',
          name: 'talent_portfolio_3',
          label: p.t('profile.form.talent_portfolio.label'),
          placeholder: p.t('profile.form.talent_portfolio.placeholder'),
          preview: '',
          constraints: null,
          required: true,
          index: 5,
          colWidth: 4,
        },
      ],
    },
  ],
  validationMessages: {
    talent_website_url: {
      invalid: p.t('profile.form.talent_website_url.invalid'),
    },
    model_birth_date: {
      invalid: p.t('profile.form.model_birth_date.invalid'),
    },
    phone_number: {
      invalid: p.t('signup.request_code.phone.invalid'),
    },
    required: p.t('general.form.required'),
  },
  submitText: p.t('profile.form.submit'),
  sending: false,
  errors: {},
});

/**
 * This is the createProfileForm reducer. It listens for actions and updates the createProfileForm object.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default function(
  state = (state = {
    fieldsets: [
      {
        legend: '',
        inputs: [],
      },
    ],
    validationMessages: {},
    submitText: '',
    sending: false,
    errors: {},
  }),
  { type, payload }
) {
  switch (type) {
    case REFRESH_LOCALE:
    case SET_READY:
      return initialState();

    case UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        sending: true,
        errors: {},
      };

    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        sending: false,
        errors: {},
      };

    case UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        sending: false,
        errors: payload.errors || {}, // @TODO: FORMAT ERRORS!
      };

    default:
      return state;
  }
}
